import { Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: ${({ theme: { token } }) => token.paddingLG}px !important;
    background-color: ${({ theme: { token } }) => token.colorBgElevated} !important;
  }

  .modal-title {
    color: ${({ theme: { token } }) => token.colorTextHeading};
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
  }

  .step-container {
    height: 100%;
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    overflow-y: auto;
  }
`;
